import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-modals',
  templateUrl: './modals.component.html',
  styleUrls: ['./modals.component.css']
})
export class ModalsComponent implements OnInit  {
  public router: string=''; 
  //public hide:boolean = true;
  constructor() {}

  ngOnInit() {
    // this._toastr.success('Success', 'Registered successfully');
    // this._toastr.warning('Warning', 'Registered successfully');
    // this._toastr.info('Info', 'Registered successfully');
    // this._toastr.error('Error', 'Registered successfully');
  }

  onCancelModel(){
    let userlogin = localStorage.getItem('user');
    if(userlogin?.length!==null){
      this.router = 'register'
    }
  }

}